/**
 * Does this club run the Simulator Companion?
 *
 * The club's own switch, flipped by Butter staff, and nothing else: no environment
 * const beside it. No production club has the switch on until staff flip it, so the
 * member surfaces that read this show nothing in production by construction. The
 * server enforces the same switch — hiding a code is a courtesy, never the control.
 *
 * A club that turns the companion OFF keeps its codes (disabling is a pause), so a
 * surface must read this AND null-check the code, never the code alone.
 */

import { useClubQuery } from '~/services/internalApi/club/hooks';

export function useSimulatorCompanionEnabled(): boolean {
  const { data: club } = useClubQuery();
  return club?.simulatorCompanionEnabled ?? false;
}
